import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
export default function CreatedDateFilter({ value, onChange }) {
    const disableStartDate = current => {
        if (!current)
            return false;
        return current.isAfter(dayjs().endOf('day'));
    };
    const disableEndDate = current => {
        if (!current)
            return false;
        if ((value === null || value === void 0 ? void 0 : value.start_date) && current.isBefore(value.start_date, 'day')) {
            return true;
        }
        return current.isAfter(dayjs().endOf('day'));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        placeholder: "Start date",
        value: value === null || value === void 0 ? void 0 : value.start_date,
        disabledDate: disableStartDate,
        onChange: date => onChange === null || onChange === void 0 ? void 0 : onChange({
            start_date: date !== null && date !== void 0 ? date : undefined,
            end_date: value === null || value === void 0 ? void 0 : value.end_date
        }),
        style: {
            width: 140
        }
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            width: 32,
            textAlign: 'center',
            lineHeight: '32px',
            color: '#999'
        }
    }, "\u2192"), /*#__PURE__*/ React.createElement(DatePicker, {
        placeholder: "End date",
        value: value === null || value === void 0 ? void 0 : value.end_date,
        disabledDate: disableEndDate,
        onChange: date => onChange === null || onChange === void 0 ? void 0 : onChange({
            start_date: value === null || value === void 0 ? void 0 : value.start_date,
            end_date: date !== null && date !== void 0 ? date : undefined
        }),
        style: {
            width: 140
        }
    }));
}
